import { render, staticRenderFns } from "./ManageTreatments.vue?vue&type=template&id=b5243664&"
import script from "./ManageTreatments.vue?vue&type=script&lang=js&"
export * from "./ManageTreatments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports